export const Links = {
    LINK_TO_VEHICLE_DETAIL: 'dashboard/vehicles/detail',
    LINK_TO_VEHICLE: 'dashboard/vehicles',
    LINK_TO_ROUTES: 'dashboard/routes',
    LINK_TO_ROUTE_DETAIL: 'dashboard/routes/detail'
};

export const Tabs = {
    performance: 'Performance',
    details: 'Details'
};

export const DataConfig = {
    firebase_url: 'https://dazzling-fire-3689.firebaseio.com/',
    authDomain: 'dazzling-fire-3689.firebaseio.com/',
    days: '2',
    day: 'sunday',
    station_type: 'bus',
    //todo remove once will have route data for other agency ,used in route api
    agency: 'NMMT',
    group: 'day',
    mapZoom: 15,
    LivemapZoom: 13,
    mapTypeId: 'terrain',
    typeNumber: 'number',
    typeString: 'string',
    typeObject: 'object',
    fill: 'none',
    strokeColor: '#2196f3',
    accent_color: '#2196f3',
    circle_stroke_opacity: 0.5,
    circle_stroke_weight: 2,
    circle_fill_opacity: 0.15,
    dateFormat: 'YYYY-MM-DD HH:mm:ss',
    AMdateFormat: 'D MMM YYYY, h:mm A',
    dayWiseFormat: 'D MMM YYYY',
    downLoadFormat: 'DD/MM/YYYY',
    hourWiseDownLoadFormat: 'DD/MM/YYYY hh:mm A',
    alertType: 'danger',
    overViewStats: 'overview',
    vehicleStats: 'vehicleStats',
    vehicleStat: 'vehicleStat',
    routeStats: 'routeStats',
    routeStat: 'routeStat',
    lat: 28.4595,
    lng: 77.0266,
    pointsRef: "production/points/",
    sessionRef: "production/sessions/",
    geoFireRef: "/production/geofire/",
    vehicleRef: "/production/vehicles/",
    routesRef: "/production/routes/",
    etaRef: "/production/eta/",
    iconBase: 'assets/',
    startIcon: 'start.png',
    endIcon: 'end.png',
    stopIcon: 'stop_marker.png',
    hour: 'hour',
    week: 'week',
    month: 'month',
    vehicleDetailFetchInterval: 10000,
    vehicleReFetchInterval: 300000,
    vehicleNotFoundMessage: "No vehicles to show",
    tripNotFoundMessage: "No trips to show",
    errorMessage: "Error while fetching, retry!",
    alertErrorMessage: "Error while fetching stats!",
    liveDataNotFound: "Unable to fetch Live trips!",
    liveETANotFound: "Unable to fetch Live ETAs!",
    alertsNotFoundMessage: "No alerts to show",
    stopArrivalsNotFoundMessage: "No Stop Arrival data available.",
    selectStop: "Select stop to fetch arrival report",
    selectVehicle: "Select vehicle to fetch arrival report",
    exceptionMessage: "Unable to handle your request!",
    exceptionMessageAgencies: "Unable to handle Agencies request!",
    credentialError: "You entered an invalid email or password.",
    noStatsToShow: "No stats to show",
    vehicle_placeholder: "Search vehicles",
    routes_placeholder: "Search routes",
    stop_arrivals_placeholder: "Search stops",
    alert_search_placeholder: "Search Routes / Vehicles",
    noLiveTrips: "No live trips to show",
    colorRange: {
        overspeeding: '#673ab7',
        routeDeviation: '#ff9800',
        bus: '#673ab7',
        overSpeedCount: '#2196f3',
        distance: '#2196f3',
    },
    NOT_AVAILABLE: 'NA',
    defaultRadius: 3,
    LIVE_MAP_INFO_MSG: 'No live buses available. Kindly change the radius or center.',
    INFO_MSG: 'Information Message',
    VEHICLE_META_MSG: 'Meta Data Information'

};
export const firebaseConst = {
    routesListingDebounceTime: 400,
    routeDetailDebounceTime:200,
    vehicleDebounceTime:300
}

export const markerIcons = {
    start: {
        icon: {
            url: DataConfig.iconBase + DataConfig.startIcon,
            scaledSize: {
                width: 70,
                height: 45
            }
        }
    },
    end: {
        icon: {
            url: DataConfig.iconBase + DataConfig.endIcon,
            scaledSize: {
                width: 70,
                height: 45
            }
        }
    },
    stop: {
        icon: {
            url: DataConfig.iconBase + DataConfig.stopIcon,
            size: {
                width: 16,
                height: 16
            }, scaledSize: {
                width: 16,
                height: 16
            }
        }

    }
};
export const colors = {
    brandColor: '#fe7c00'
}
export const toastOptions = {
    title: "",
    msg: "",
    theme: 'default',
    timeout: 2500
};
/**
 * @description sorts the list of items
 * @param items
 * @returns {any}
 */
export function sortPoints(items): any {
    items.sort(function (a, b) {
        return (a.time - b.time);

    });
    return items;
}
export function sortByStartTime(items): any {
    items.sort(function (a, b) {
        return (b.startTime - a.startTime);

    });
    return items;
}
export function sortByStartTimeAndActive(items): any {
    items.sort(function (a, b) {
        if (a.active === b.active)
            return b.startTime - a.startTime;
        else if (a.active)
            return -1;
        else return 1;
    });
    return items;
}
export function sortByActiveStatus(items): any {
    items.sort(function (a, b) {
        if (a.isActive === b.isActive)
            return b.timeStamp - a.timeStamp;
        else if (a.isActive)
            return -1;
        else return 1;
    });
    return items;
}

export function sortByNumberColumn(items, column, sortType): any {
    items.sort(function (a, b) {
        a[column] = a.hasOwnProperty(column) ? a[column] : 0;
        b[column] = b.hasOwnProperty(column) ? b[column] : 0;
        if (typeof a[column] === 'number' && typeof b[column] === 'number') {
            if (sortType === 'asc') {
                return (a[column] - b[column]);
            }
            if (sortType === 'desc') {
                return (b[column] - a[column]);
            }
        }
    });
    return items;
}

export enum StatType{
    Overview,
    Route,
    Vehicle
}
export enum AlertType{
    routeDeviation=<any>"routeDeviation",
    overSpeed=<any>"overSpeed",
}

